import Swiper, { Navigation, Thumbs } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

class ProductMediaGallery extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.thumbs = new Swiper('.swiper-product-media-thumbs', {
            spaceBetween: 15,
            slidesPerView: 5.4,
            freeMode: true,
            watchSlidesProgress: true,
            threshold: 12,
        });

        this.gallery = new Swiper('.swiper-product-media-gallery .swiper', {
            modules: [Navigation, Thumbs],
            navigation: {
                nextEl: '.swiper-product-media-gallery .swiper-button-next',
                prevEl: '.swiper-product-media-gallery .swiper-button-prev',
            },
            slidesPerView: 1,
            thumbs: {
                swiper: this.thumbs,
            },
        });
        const initialMedia = this.dataset.initialMedia;
        if (initialMedia) this.setActiveMedia(initialMedia);
    }

    setActiveMedia(mediaId) {
        const slide = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (slide?.dataset?.index) {
            this.gallery.slideTo(slide.dataset.index, 0);
        }
    }
}

customElements.define('product-media-gallery', ProductMediaGallery);
